/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1ApplicationKind = {
    APP_KIND_COACH: 'coach',
    APP_KIND_BUSINESS: 'business'
} as const
export type V1ApplicationKind =
    (typeof V1ApplicationKind)[keyof typeof V1ApplicationKind]

export function instanceOfV1ApplicationKind(value: any): boolean {
    for (const key in V1ApplicationKind) {
        if (Object.prototype.hasOwnProperty.call(V1ApplicationKind, key)) {
            if (
                V1ApplicationKind[key as keyof typeof V1ApplicationKind] ===
                value
            ) {
                return true
            }
        }
    }
    return false
}

export function V1ApplicationKindFromJSON(json: any): V1ApplicationKind {
    return V1ApplicationKindFromJSONTyped(json, false)
}

export function V1ApplicationKindFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1ApplicationKind {
    return json as V1ApplicationKind
}

export function V1ApplicationKindToJSON(value?: V1ApplicationKind | null): any {
    return value as any
}

export function V1ApplicationKindToJSONTyped(
    value: any,
    ignoreDiscriminator: boolean
): V1ApplicationKind {
    return value as V1ApplicationKind
}
